module.exports = __webpack_public_path__ + "img/ME2.20f14444.jpg";